import cabErrorImage from '@/assets/api-error.png?url';
import cabExclamImage from '@/assets/api-warning.png?url';
import {
	ErrorLayout,
	type ErrorLayoutProps,
} from '@/components/error-states/Layout';
import { ApiFailed } from '@/components/icons';
import type {
	CancellationErrorResponse,
	CancellationErrorType,
} from '../../-api/cancellation';

const CANCELLATION_ERROR_MAP: Record<
	CancellationErrorType,
	{ image: React.ReactNode | string; btnText: string }
> = {
	RETURN_HOME: {
		image: cabExclamImage,
		btnText: 'Go to Home',
	},
	RETRY: {
		image: cabErrorImage,
		btnText: 'Try Again',
	},
	REFRESH: {
		image: <ApiFailed />,
		btnText: 'Refresh',
	},
	GENERIC_ERROR: {
		image: cabErrorImage,
		btnText: 'Go to Home',
	},
	NOT_ALLOWED: {
		image: cabErrorImage,
		btnText: 'Okay',
	},
};

const FALLBACK_TITLE = "Sorry! We couldn't load cancellation details.";
const FALLBACK_DESCRIPTION =
	'Please refresh the page or try again. If the problem persists, go to home.';

export interface CancellationErrorViewProps
	extends Omit<ErrorLayoutProps, 'buttonText' | 'description' | 'title'> {
	error?: CancellationErrorResponse['errors'] | null;
	onAction?: () => void;
}

export const CancellationErrorView = ({
	error,
	onAction,
	fullScreen = false,
	...restProps
}: CancellationErrorViewProps) => {
	const errorType: CancellationErrorType =
		error?.type && CANCELLATION_ERROR_MAP[error.type]
			? error.type
			: 'GENERIC_ERROR';

	const title = error?.title ?? FALLBACK_TITLE;
	const description = error?.message ?? FALLBACK_DESCRIPTION;
	const { image, btnText } = CANCELLATION_ERROR_MAP[errorType];

	return (
		<ErrorLayout
			title={title}
			description={description}
			buttonText={btnText}
			buttonProps={{
				onClick: () => {
					onAction?.();
				},
			}}
			{...restProps}
		>
			<div className="flex justify-center items-center">
				{typeof image === 'string' ? (
					<img src={image} alt="Error" className="size-100 object-contain" />
				) : (
					<div className="size-100 flex items-center justify-center">
						{image}
					</div>
				)}
			</div>
		</ErrorLayout>
	);
};
